import styled from "styled-components";

interface SpacerProps {
  all?: number;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
  children?: any;
}

const StyledSpacer = styled.div<{
  top: number;
  right: number;
  bottom: number;
  left: number;
}>`
  padding-top: ${({ top }) => top}rem;
  padding-right: ${({ right }) => right}rem;
  padding-bottom: ${({ bottom }) => bottom}rem;
  padding-left: ${({ left }) => left}rem;
`;

const Spacer = ({
  all = 0,
  top = 0,
  right = 0,
  bottom = 0,
  left = 0,
  children,
  ...props
}: SpacerProps) => {
  if (all != 0) {
    top = all;
    right = all;
    bottom = all;
    left = all;
  }
  return (
    <StyledSpacer
      top={top}
      right={right}
      bottom={bottom}
      left={left}
      {...props}
    >
      {children}
    </StyledSpacer>
  );
};

export default Spacer;
